// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2gOgu","header":"Messages_header__1d8oK"};